/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OepvMode model module.
 * @module model/OepvMode
 * @version 0.0.2
 */
export class OepvMode extends Array {
  /**
   * Constructs a new <code>OepvMode</code>.
   * oepv modes allowed in the current transport variant
   * @alias module:model/OepvMode
   * @class
   * @extends Array
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>OepvMode</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OepvMode} obj Optional instance to populate.
   * @return {module:model/OepvMode} The populated <code>OepvMode</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OepvMode();
      ApiClient.constructFromObject(data, obj, 'String');
    }
    return obj;
  }
}
